/* Saint Croix · tallas rápidas en la tarjeta de producto
   Botón + (móvil): abre y cierra la columna de tallas. Al cambiar de color, enseña solo
   las tallas disponibles de ese color. Al añadir una talla, la columna se cierra. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  function setQuick(card, on) {
    if (!card) return;
    card.classList.toggle('is-q', on);
    const b = $('[data-plus]', card); if (b) b.setAttribute('aria-expanded', String(on));
  }
  function rebuild(card) {
    const s = $('script[data-card-json]', card), q = $('.card-quick', card), list = q && $('.q-s', q), plus = $('[data-plus]', card);
    let d = null; try { d = s ? JSON.parse(s.textContent) : null; } catch (e) { d = null; }
    if (!d || !d.s || !list) return;
    const color = card.dataset.c, sizes = [];
    d.v.forEach(x => { if (x[d.c] === color && x[4] && !sizes.some(z => z[0] === x[d.s])) sizes.push([x[d.s], x[0]]); });
    q.style.setProperty('--n', sizes.length || 1);
    list.innerHTML = sizes.map(([name, id], k) => `<button type="button" class="q-b" data-qa="${id}" style="--k:${k}">${esc(name)}</button>`).join('');
    q.hidden = !sizes.length;
    if (plus) plus.hidden = !sizes.length;
    if (!sizes.length) setQuick(card, false);
  }
  document.addEventListener('click', e => {
    const t = e.target; if (!(t instanceof Element)) return;
    $$('.card.is-q').forEach(c => { if (!c.contains(t)) setQuick(c, false); });
    const plus = t.closest('[data-plus]');
    if (plus) { e.preventDefault(); const c = plus.closest('.card'); if (c) setQuick(c, !c.classList.contains('is-q')); return; }
    const dot = t.closest('.card [data-dot]');
    if (dot) { const c = dot.closest('.card'); rebuild(c); requestAnimationFrame(() => rebuild(c)); return; }
    const qa = t.closest('.card-quick [data-qa]');
    if (qa) { const c = qa.closest('.card'); setTimeout(() => setQuick(c, false), RM ? 0 : 250); }
  });
})();
